import React from 'react';
import cx from './cx';

const AppTextarea = ({ className = '', size, inputRef, ...rest }) => (
  <textarea
    ref={inputRef}
    className={cx('form-control', size === 'sm' && 'form-control-sm', className)}
    {...rest}
  />
);

export default AppTextarea;
